import React from 'react';
import { FileAlt, FileBlank, FolderMinus, GraphBar } from '@bancobarigui/barihaus';

interface MenuItem {
  key: string;
  label: string;
  path: string;
  icon?: React.ReactNode;
  children?: MenuItem[];
}

export const MENU_ITEMS: MenuItem[] = [
  {
    key: '/dashboard',
    label: 'Visão geral',
    path: '/dashboard',
    icon: React.createElement(GraphBar),
  },
  {
    key: '/proposal',
    label: 'Cadastro de proposta',
    path: '/proposal',
    icon: React.createElement(FileBlank),
  },
  {
    key: '/manage-proposal',
    label: 'Gerenciar proposta',
    path: '/manage-proposal',
    icon: React.createElement(FolderMinus),
  },
  {
    key: '/reports',
    label: 'Relatórios',
    path: '/reports',
    icon: React.createElement(FileAlt),
  },
];
